import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import { TransactionType } from "@tggstore/Services/CommonServices";
import loadTransactionTypeOptions from "@tggstore/Store/Handlers/Custom/LoadTransactionTypeOptions";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    transactionTypes: (state as any).customTransactionTypeOptions.transactionTypes,
    parameter: state.pages.orderHistory.getOrdersParameter,
});

const mapDispatchToProps = {
    updateSearchFields,
    loadTransactionTypeOptions,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldTransactionTypeStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const transactionTypeStyles: OrderHistorySearchFieldTransactionTypeStyles = {};
const styles = transactionTypeStyles;

const findDisplayName = (erpCode: string, transactionTypes: TransactionType[] = []) => {
    const option = transactionTypes.find(t => t.erpCode === erpCode);
    return option?.displayName;
};

const OrderHistorySearchFieldTransactionType: React.FC<Props> = ({
    transactionTypes,
    parameter,
    updateSearchFields,
    loadTransactionTypeOptions,
}) => {
    React.useEffect(() => {
        if (!transactionTypes || transactionTypes.length === 0) {
            loadTransactionTypeOptions({});
        }
    }, [transactionTypes]);

    const handleChange = React.useCallback(
        (event: React.FormEvent<HTMLSelectElement>) => {
            if (event.currentTarget.value) {
                updateSearchFields({
                    additionalQueryStringParameters: { transactionType: event.currentTarget.value },
                    displayName: findDisplayName(event.currentTarget.value, transactionTypes),
                });
            } else {
                updateSearchFields({ additionalQueryStringParameters: { transactionType: undefined } });
            }
        },
        [transactionTypes, updateSearchFields],
    );

    const value = parameter.additionalQueryStringParameters?.transactionType || "";

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <Select
                label={translate("Transaction Type")}
                {...styles.select}
                value={value}
                onChange={handleChange}
                data-test-selector="orderHistory_filterTransactionType"
            >
                <option value="">{translate("Select")}</option>
                {(transactionTypes || []).map((option: TransactionType) => (
                    <option key={option.erpCode} value={option.erpCode}>
                        {option.displayName}
                    </option>
                ))}
            </Select>
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldTransactionType),
    definition: {
        group: "Order History",
        displayName: "Transaction Type",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
